import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// Importing the specific actions from your slice
import { 
    fetchIntegratedAssessments, 
    deleteIntegratedAssessment 
} from "../store/slices/integratedAssessmentSlice"; 
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import IntegratedInitialAssessmentList from "./IntegratedAssessment/IntegratedAssessmentList";

const IntegratedInitialAssessments = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Mapping to your slice's initial state names: records and isLoading
    const { records, isLoading } = useSelector((state) => state.integratedAssessments);

    useEffect(() => {
        dispatch(fetchIntegratedAssessments());
    }, [dispatch]);

    const handleAdd = () => 
        navigate("/residential/phase-01/integrated-initial-assessment/add");

    // const handleEdit = (id) => {
    //     const assessment = records.find(a => a.id === id);
    //     navigate(`/residential/phase-01/integrated-initial-assessment/edit/${id}`, { 
    //         state: { assessment } 
    //     });
    // };

    const handleEditRecord = (id) => navigate(`/residential/phase-01/integrated-initial-assessment/edit/${id}`);

    const handleDelete = async (id) => {
        // Dispatch the thunk and unwrap to handle the try/catch in the child component
        return await dispatch(deleteIntegratedAssessment(id)).unwrap();
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <IntegratedInitialAssessmentList
                            records={records}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEditRecord}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default IntegratedInitialAssessments;